import React from "react";
import Header from "./Header"
import Info from "./Info"
import Project from "./Projects"
import Contact from "./Contact"
import Footer from "./Footer"
import Landing from "./landing";

function App() {
  

  return (
    <div>
      <Header />
      <Landing />
      <Info />
      <Project />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;